import { CustomAccordion } from 'components/CustomAccordion/CustomAccordion'
import { useContractStore } from 'context/ContractStore'
import React, { memo } from 'react'




export const DetailsTab = memo(({ readonly = false }) => {
  const {
    contractStore: { loanApplicationData }
  } = useContractStore()



  const detailsData = data => {
    if (!data) return []

    return [
      { label: 'ИИК', value: data?.dealerBankIik || 'Нет данных' },
      { label: 'Банк-получатель', value: data?.dealerBankName || 'Нет данных' },
      { label: 'БИК банка', value: data?.dealerBankBik || 'Нет данных' },
      { label: 'КБЕ', value: data?.dealerBankKbe || 'Нет данных' },
      { label: 'Получатель', value: data?.dealerDataName || 'Нет данных' },
      { label: 'БИН партнера', value: data?.dealerDataBin|| 'Нет данных' } ,
      { label: 'Бин Банка Получателя', value: data?.dealerBankBin || 'Нет данных' }

    ]
  }
  return (
    <>
      <CustomAccordion title="Реквизиты" data={detailsData(loanApplicationData?.requisites)} readonly={readonly} />
    </>
  )
})
